"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JstChart = undefined;
var _assign = require("babel-runtime/core-js/object/assign");
var _assign2 = _interopRequireDefault(_assign);
var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require("babel-runtime/helpers/createClass");
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require("babel-runtime/helpers/inherits");
var _inherits3 = _interopRequireDefault(_inherits2);
var _jayesstee = require("jayesstee");
var _jayesstee2 = _interopRequireDefault(_jayesstee);
var _chart = require("chart.js");
var _chart2 = _interopRequireDefault(_chart);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var JstChart = exports.JstChart = function (_jst$Object) {
  (0, _inherits3.default)(JstChart, _jst$Object);
  function JstChart(optsAndData) {
    (0, _classCallCheck3.default)(this, JstChart);
    var _this = (0, _possibleConstructorReturn3.default)(this, (JstChart.__proto__ || (0, _getPrototypeOf2.default)(JstChart)).call(this));
    _this.initialOptsAndData = optsAndData;
    return _this;
  }
  (0, _createClass3.default)(JstChart, [{
    key: "render",
    value: function render() {
      return _jayesstee2.default.$div({
        cn: "-chart"
      }, _jayesstee2.default.$canvas({
        ref: "chartCanvas"
      }));
    }
  }, {
    key: "postRender",
    value: function postRender() {
      var chartContext = this.chartCanvas.el.getContext("2d");
      if (this.chart) {
        this.chart.update();
      } else {
        this.chart = new _chart2.default(chartContext, this.initialOptsAndData);
        delete this.initialOptsAndData;
      }
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(opts) {
      this.chart.options = (0, _assign2.default)(this.chart.options, opts);
      this.refresh();
    }
  }, {
    key: "setOptions",
    value: function setOptions(opts) {
      this.chart.options = opts;
      this.refresh();
    }
  }, {
    key: "updateDataset",
    value: function updateDataset(label, dataset) {
      var index = this.chart.labels.indexOf(label);
      if (index >= 0) {
        this.chart.datasets[index] = dataset;
        this.refresh();
      }
    }
  }, {
    key: "removeDataset",
    value: function removeDataset(label) {
      var index = this.chart.labels.indexOf(label);
      if (index >= 0) {
        this.chart.datasets.splice(index, 1);
        this.chart.labels.splice(index, 1);
        this.refresh();
      }
    }
  }, {
    key: "addDataset",
    value: function addDataset(label, dataset) {
      this.chart.datasets.push(dataset);
      this.chart.label.push(label);
    }
  }]);
  return JstChart;
}(_jayesstee2.default.Object);